import { Utils } from 'cc-common';

export class VendorContractBaseParameterDto {
    vendorContractId: number;
    communityVendorId: number;
    vendorCode: string;
    communityId: number;
    clearCache: boolean;

    getQueryString(): string {
        const tokens = [];
        if (Utils.notNullAndDefined(this.vendorContractId)) {
            tokens.push(`vendorContractId=${this.vendorContractId}`);
        }
        if (Utils.notNullAndDefined(this.communityVendorId)) {
            tokens.push(`communityVendorId=${this.communityVendorId}`);
        }
        if (Utils.notNullAndDefined(this.vendorCode)) {
            tokens.push(`vendorCode=${this.vendorCode}`);
        }
        if (Utils.notNullAndDefined(this.communityId)) {
            tokens.push(`communityId=${this.communityId}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
